import BaseAction from "../base-action";

class Wayfinding extends BaseAction {
    targetType;
    distanceThreshold;
    pathColor;
    timelines;
    prune;
    selectedPoint;
    volume;
    model;
    visible;

    constructor(props = {}) {
        super(props);

        this.distanceThreshold = !isNullOrUndefined(props.distanceThreshold) ? props.distanceThreshold : WayfindingConstants.distanceThreshold;
        this.timelines = props.timelines || [];
        this.prune = props.prune || {};
        this.pathColor = props.pathColor || WayfindingConstants.pathColor;
        this.selectedPoint = props.selectedPoint ? new THREE.Vector3(props.selectedPoint.x, props.selectedPoint.y, props.selectedPoint.z) : new THREE.Vector3();
        this.volume = props.volume || {id: "", name: ""};
        this.model = props.model || {id: "", name: "", alias: ""};
        this.visible = isNullOrUndefined(props.visible) ? true : props.visible;
    }
}

export default Wayfinding;